// extracted by mini-css-extract-plugin
export default {"root":"weeks_root__ryJro","title":"weeks_title__SIjyw"};